var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 47 47",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#27d8ff" },
        attrs: {
          d: "M6.1 0h34.7c3.4 0 6.1 2.7 6.1 6.1v34.7c0 3.4-2.7 6.1-6.1 6.1H6.1c-3.4 0-6.1-2.7-6.1-6.1V6.1C0 2.7 2.7 0 6.1 0z",
        },
      }),
      _c("defs", [
        _c("path", {
          attrs: {
            id: "a",
            d: "M6.2 0h34.7C44.2 0 47 2.8 47 6.2v34.7c0 3.4-2.7 6.1-6.1 6.1H6.2C2.8 47 0 44.2 0 40.8V6.2C0 2.8 2.8 0 6.2 0z",
          },
        }),
      ]),
      _c("clipPath", { attrs: { id: "b" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#a" },
        }),
      ]),
      _c("ellipse", {
        staticStyle: { "clip-path": "url(#b)", fill: "#83f8ff" },
        attrs: { cx: "14.4", cy: "36.6", rx: "26.9", ry: "27.8" },
      }),
      _c("ellipse", {
        staticStyle: { "clip-path": "url(#b)", fill: "#06e7f7" },
        attrs: { cx: "11.8", cy: "38.9", rx: "17.2", ry: "17.7" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }